export default "__VITE_ASSET__DF7lus6b__"